import React, { useEffect, useRef, useState } from 'react';
import "../../../src/App.scss";
import Box from "@material-ui/core/Box";
import { Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { dataService } from "../../Services/data/data.service";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Input from "@mui/material/Input";
import Quagga from 'quagga';
import { IconButton } from '@mui/material';
import { BiBarcodeReader } from 'react-icons/bi';
import { useTranslation } from 'react-i18next';


function ScannerPage(props) {
  /* Hooks section start */
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);
  const [popupEnable, setPopupEnable] = useState(true);
  const [allPausedDataList, setAllPausedDataList] = useState(props.location.state.pausedDetailList || []);
  const [getListData, setListData] = useState(props.location.state.listDetail);
  const [showCarrierNumber, setShowCarrierNumber] = useState();
  const [carrierNumberColor, setCarrierNumberColor] = useState("");
  const [carrierNumberSize, setCarrierNumberSize] = useState("");
  const [checkNavigation, setcheckNavigation] = useState(props.location.state.checkNavigation);
  const [getCheckedList, setCheckedList] = useState(props.location.state.checkedList || []);
  const [compareArray, setCompareArray] = useState([]);

  const [showNextButton, setShowNextButton] = React.useState(true);
  const [isStart, setIsStart] = useState(false);
  const [barcode, setBarcode] = useState('');
  const [getCartId, setCartId] = useState(0);
  const firstUpdate = useRef(true);
  const [isCartMatched, setIsCartMatched] = useState(false);
  let history = useHistory();


  useEffect(() => {

    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }

    if (isStart) startScanner();
    else stopScanner();
  }, [isStart]);
  /* Hooks section end */

  /* Global variables */


  /* Handler functions section start */

  /* Check the barcode value from DB */
  const handleQrCodeScanner = (barcodeValue) => {
    let compare = [];
    dataService.sendCarrierByBarcode(barcodeValue).then((result) => {
      if (result === null) {
        setCarrierNumberColor("red");
        setShowNextButton(true);
      }
      if (result.length > 0 && result[0] !== null) {
        if (result[0].numberOfStockAttached > 0) {
          setCarrierNumberColor("pink");
          setShowNextButton(true);
        } else {
          compare = handleCompare(result[0].id);
          setCompareArray(compare);
          setCartId(result[0].id);
          if (compare.length > 0) {
            setIsCartMatched(true);
            setShowCarrierNumber(result[0].carrierNumber); // Cart no. Matched with Paused list data (Already in use)
            setCarrierNumberColor("orange");
            setCarrierNumberSize("48px");
            setShowNextButton(false);
          }
          if (compare.length < 1) {
            setIsCartMatched(false);
            setShowCarrierNumber(result[0].carrierNumber); // Cart no. Not Matched with Paused list data but exist in db (Already not in use)
            setCarrierNumberColor("green");
            setShowNextButton(false)
            let metaData = JSON.parse(getListData.workflowSteps[0].metaData);
            metaData[0].MetaData[0].CartNumber = result[0].carrierNumber;
            let updatedMetaData = JSON.stringify(metaData);
            getListData.workflowSteps[0].metaData = updatedMetaData;
          }
        }
      } else {
        setCarrierNumberColor("black");
        setShowNextButton(true)
      }
    })
      .catch((error) => {
        toast.error(error, { position: toast.POSITION.TOP_CENTER });
      });
  };

  /* To navigate to picking detail screen*/
  const goToPickingDetail = () => {
    let compare = [...compareArray];

    if (checkNavigation === "PickingDetail") {
      let IdArray = [];
      getCheckedList.map((item) => {
        IdArray.push(item.id)
      })

      if (carrierNumberColor !== 'orange') {
        dataService.sendChangeCarrier("", props.location.state.previousCartCode, getCartId, getListData.id).then((result) => {
          if (result) {
            history.push({
              pathname: "/PickingDetail",
              state: {
                pausedDetailList: allPausedDataList,
                listDetail: isCartMatched ? compare[0] : getListData,
                tempArr: isCartMatched ? toCheckBoxes(compare[0].workflowSteps[0].workflowStepDetails.length) : props.location.state.tempArr,
              },
            });
          }
        }).catch((error) => {
          toast.error(error, { position: toast.POSITION.TOP_CENTER });
        });
      }
      else {
        history.push({
          pathname: "/PickingDetail",
          state: {
            pausedDetailList: allPausedDataList,
            listDetail: isCartMatched ? compare[0] : getListData,
            tempArr: isCartMatched
              ? toCheckBoxes(
                compare[0].workflowSteps[0].workflowStepDetails.length
              )
              : props.location.state.tempArr,
          },
        });
      }

    } else {
      if (!isCartMatched) {
        let metaData = JSON.parse(getListData.workflowSteps[0].metaData);
        metaData[0].MetaData[0].CartNumber = showCarrierNumber;
        let updatedMetaData = JSON.stringify(metaData)
        getListData.workflowSteps[0].metaData = updatedMetaData;

      }
      history.push({
        pathname: "/PickingDetail",
        state: {
          pausedDetailList: allPausedDataList,
          listDetail: isCartMatched ? compare[0] : getListData,
          tempArr: isCartMatched ? toCheckBoxes(compare[0].workflowSteps[0].workflowStepDetails.length) : props.location.state.tempArr,
        },
      });
    }
  };


  /** To navigate on landing page */
  const handleGoBack = () => {
    let compare = [...compareArray];

    if (props.location.state.checkNavigation === "PickingDetail") {
      history.push({
        pathname: "/PickingDetail",
        state: {
          pausedDetailList: allPausedDataList,
          listDetail: isCartMatched ? compare[0] : getListData,
          tempArr: isCartMatched ? toCheckBoxes(compare[0].workflowSteps[0].workflowStepDetails.length) : props.location.state.tempArr,
        },
      });
    }
    else {
      history.replace("/");
    }
  };

  /* Scan the QR Code */
  const onFindScanner = (value) => {
    if (value) {
      handleQrCodeScanner(value);
    }
  };
  const changeBarcode = (e) => {
    setBarcode(e.target.value);
  }
  const handleKeyPress = (e) => {
    if (e.keyCode === 13) {
      handleQrCodeScanner(e.target.value);
    }
  }

  /* To close dialog*/
  const handleClickOpen = () => {
    setOpen(true)
    setTimeout(() => {
      setIsStart(!isStart)
    }, 0)
  };


  /* To close dialog*/
  const handleClose = () => {
    setOpen(false);
    setIsStart(!isStart)

  };

  /* Compares the cart number */
  const handleCompare = (id) => {
    return allPausedDataList.filter((item) => {
      if (item.cartNumber === id) {
        return item;
      }
    });
  };

  /* Handler functions section end */


  //// Scanning functionality START
  const _onDetected = res => {
    // stopScanner();
    if (res.codeResult.code) {
      setBarcode(res.codeResult.code);
      onFindScanner(res.codeResult.code)
      setIsStart(false)

      setOpen(false)
    }
  };

  const startScanner = () => {
    Quagga.init(
      {
        inputStream: {

          type: 'LiveStream',
          target: document.querySelector('#scanner-container'),
          constraints: {
            facingMode: 'environment' // or user
          }
        },
        numOfWorkers: navigator.hardwareConcurrency,
        locate: true,
        frequency: 1,
        debug: {
          drawBoundingBox: true,
          showFrequency: true,
          drawScanline: true,
          showPattern: true
        },
        multiple: false,
        locator: {
          halfSample: true,
          patchSize: 'large', // x-small, small, medium, large, x-large
          debug: {
            showCanvas: false,
            showPatches: false,
            showFoundPatches: false,
            showSkeleton: false,
            showLabels: false,
            showPatchLabels: false,
            showRemainingPatchLabels: false,
            boxFromPatches: {
              showTransformed: false,
              showTransformedBox: false,
              showBB: false
            }
          }
        },
        decoder: {
          readers: props.readers
        }
      },
      err => {
        if (err) {
          return console.log(err);
        }
        Quagga.start();
      }
    );
    Quagga.onDetected(_onDetected);
    Quagga.onProcessed(result => {
      let drawingCtx = Quagga.canvas.ctx.overlay,
        drawingCanvas = Quagga.canvas.dom.overlay;

      if (result) {
        if (result.boxes) {
          drawingCtx.clearRect(
            0,
            0,
            parseInt(drawingCanvas.getAttribute('width')),
            parseInt(drawingCanvas.getAttribute('height'))
          );
          result.boxes.filter(box => box !== result.box).forEach(box => {
            Quagga.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, {
              color: 'green',
              lineWidth: 2
            });
          });
        }

        if (result.box) {
          Quagga.ImageDebug.drawPath(result.box, { x: 0, y: 1 }, drawingCtx, { color: '#00F', lineWidth: 2 });
        }

        if (result.codeResult && result.codeResult.code) {
          Quagga.ImageDebug.drawPath(result.line, { x: 'x', y: 'y' }, drawingCtx, { color: 'red', lineWidth: 3 });
        }
      }
    });
  };

  const stopScanner = () => {
    Quagga.offProcessed();
    Quagga.offDetected();
    Quagga.stop();
  };
  //// Scanning functionality END  

  const toCheckBoxes = (Listlenth) => {
    let newArr = [];
    for (let i = 0; i < Listlenth; i++) {
      newArr.push(false);
    }
    return newArr;
  };

  return (
    <React.Fragment>
      <Box
        display="flex"
        flexDirection="column"
        flexGrow="1"
        style={{ paddingBottom: "110px" }}
      >
        {/* <Paper elevation={0} style={{ backgroundColor: "whitesmoke" }}>
          <h4 className="heading"> TOEKENNEN VAN KAR</h4>
        </Paper> */}
        <div style={{ display: 'block', width: '100%', maxWidth: '100%', padding: 0, backgroundColor: "whitesmoke", borderBottom: '1px solid darkgrey' }}>
          <h3 className="heading" style={{ paddingLeft: '5px', paddingRight: '10px', paddingLeft: '10px' }}>{t('TOEKENNEN VAN KAR')}</h3>
        </div>
        <Box px={2} height="100%">
          <div style={{ display: 'flex', marginTop: "50pt" }}>
            <Input
              placeholder={t("Scan je karnummer in")}
              fullWidth
              value={barcode}
              onChange={(e) => changeBarcode(e)}
              onKeyUp={(e) => handleKeyPress(e)}
              // onClick={(event) => (popupEnable ? handleOpenScanner() : false)}
              style={{ outline: "none" }}
            />
            <IconButton onClick={(event) => (popupEnable ? handleClickOpen() : false)}>
              <BiBarcodeReader></BiBarcodeReader>
            </IconButton>

          </div>

          {carrierNumberColor === "black" && (
            <p style={{ color: "red", position: 'absolute' }}>
              {/* This is not a valid cart. Please scan a valid cart. */}
              {t('Dit is geen geldige kar. Scan een geldig karnummer')}.
            </p>
          )}
          {carrierNumberColor === "red" && (
            <p style={{ color: "red", position: 'absolute' }}>
              {/* This is not a valid cart. Please scan a valid cart. */}
              {t('Er heeft zich een fout voorgedaan op de server')}.
            </p>
          )}

          {carrierNumberColor === "pink" && (
            <p style={{ color: "red", position: 'absolute' }}>
              {/* This is not a valid cart. Please scan a valid cart. */}
              {t('De kar is al in gebruik')}.
            </p>
          )}
          <Box
            style={{ height: "calc(100% - 40px)" }}
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
          >

            <Typography
              component="h2"
              variant="h4"
              style={{
                color: carrierNumberColor,
                fontSize: carrierNumberSize ? carrierNumberSize : "36px", textAlign: "center",
                marginTop: '10px',
                height: '90px',
                backgroundColor: 'rgb(200, 200, 200)',
                display: 'flex',
                justifyContent: 'center',
                width: '80%',
                borderRadius: '6px',
                alignItems: 'center',
                border: '2px solid darkgrey'
              }}
            >
              <span style={{ borderBottom: '1px solid black', width: '90%', height: '46px' }}>{(showCarrierNumber !== undefined && showCarrierNumber !== null) ? showCarrierNumber : " "}</span>
            </Typography>
            <Typography style={{ color: "orange" }} align="center">
              {carrierNumberColor === "orange" ? (
                <>
                  {/* Cart already in use. Do you want to continue with this cart
                  and discard the selected new picking list? */}
                  {t('Winkelwagen al in gebruik. Wilt u doorgaan met deze winkelwagen en de geselecteerde nieuwe picklijst verwijderen')}?
                </>
              ) : carrierNumberColor === "green" ? (
                ""
              ) : (
                ""
              )}
            </Typography>
          </Box>
          <div>

          </div>

          <div className="footer">
            <Box display="flex">
              <Box mx={1} flexGrow="1">
                <Button
                  variant="contained"
                  fullWidth
                  size="large"
                  className="btn-blue"
                  onClick={() => handleGoBack()}
                  style={{ borderRadius: '8px' }}
                >
                  {t('Terug')}
                </Button>
              </Box>
              <Box mx={1} flexGrow="1">
                <Button
                  variant="contained"
                  fullWidth
                  size="large"
                  className="btn-blue"
                  onClick={() => goToPickingDetail()}
                  disabled={showNextButton}
                  style={{ borderRadius: '8px' }}
                >
                  {t('Volgende')}
                </Button>
              </Box>
            </Box>
          </div>
        </Box>
      </Box>

      {/* Scanner Dialog  */}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description "
        maxWidth="sm"
      >
        <DialogContent className="scanner">

          {isStart && <React.Fragment>
            <div id="scanner-container" />
          </React.Fragment>}

        </DialogContent>
      </Dialog>

    </React.Fragment>
  );
}
export default ScannerPage;
